import * as types from '../actionTypes/auditLog'

export function getAuditLogTypeNames(typeNames) {
  return {
    type: types.GET_AUDIT_LOG_TYPE_NAMES,
    typeNames
  }
}

export function getAuditLogEntries(auditLogEntries) {
  return {
    type: types.GET_AUDIT_LOG_ENTRIES,
    auditLogEntries
  }
}

export function logUserAction() {
  return {
  }
}




// WEBPACK FOOTER //
// ./src/actions/auditLog.js